import { BookingSlotType } from '@/types/BookingSlotType'
import React from 'react'
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap'

interface EditFormModalType {
    show: boolean
    setShow: React.Dispatch<React.SetStateAction<boolean>>
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
    onSubmitLoading: boolean
    bookingInput: BookingSlotType | undefined
}

export function EditFormModal ({editFormModalProps}: {editFormModalProps: EditFormModalType}) {
    const {show, setShow, handleSubmit, onSubmitLoading, bookingInput} = editFormModalProps

    return (
      <Modal show={show} onHide={() => setShow(false)} size='lg'>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton className='bg-dark'>
            <Modal.Title className='text-white'>Modifier le booking</Modal.Title>
          </Modal.Header>
          <Modal.Body className='p-5'>
            <input type='hidden' name='id' defaultValue={bookingInput?.id} />
            <Form.Group as={Row} className='mb-3'>
              <Form.Label column sm={4}>
                Nombre de casier à réserver <span className='text-danger'>*</span>
              </Form.Label>
              <Col sm={8}>
                <input
                  type='hidden'
                  name='slot_available'
                  value={bookingInput?.slot?.available}
                />
                <InputGroup>
                  <Form.Control
                    type='text'
                    defaultValue={bookingInput?.capacity}
                    name='capacity'
                  />
                </InputGroup>
                <span className='text-muted mt-2 d-block'>
                  Casiers disponibles : {bookingInput?.slot?.available}
                </span>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShow(false)}>
              Annuler
            </Button>
            <Button variant='dark' type='submit'>
              {onSubmitLoading ? <Spinner size={'sm'} /> : 'Enregistrer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    )
}